import bingoModalSelect from './index.vue';
export default bingoModalSelect;



// WEBPACK FOOTER //
// ./src/components/bingo-modal-select/index.js